'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Name;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _radio = require('../components/radio');
var _radio2 = _interopRequireDefault(_radio);
var _input = require('../components/input');
var _input2 = _interopRequireDefault(_input);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
Name.propTypes = {
  titles: _propTypes.array
};
Name.defaultProps = {
  titles: []
};
function Name(props) {
  return _react2.default.createElement('div', null, _react2.default.createElement(_radio2.default, {
    type: 'radio',
    name: 'title',
    label: 'Title',
    options: props.titles
  }), _react2.default.createElement(_input2.default, {
    name: 'forenames',
    label: 'First name(s)'
  }), _react2.default.createElement(_input2.default, {
    name: 'surname',
    label: 'Last name'
  }));
}